import { render } from "./ModalSnExped.vue?vue&type=template&id=22a06e46"
import script from "./ModalSnExped.vue?vue&type=script&lang=ts"
export * from "./ModalSnExped.vue?vue&type=script&lang=ts"

import "./ModalSnExped.vue?vue&type=style&index=0&id=22a06e46&lang=css"
script.render = render

export default script